<div class="filter-panel">

  <mat-form-field appearance="outline" class="search-field">

    <mat-label>
      Search Patient / Doctor
    </mat-label>

    <input matInput [(ngModel)]="search" (ngModelChange)="onSearchChange($event)">

    <mat-icon matSuffix>
      search
    </mat-icon>

  </mat-form-field>

  <mat-form-field appearance="outline">

    <mat-label>
      From Date
    </mat-label>

    <input matInput [matDatepicker]="fromPicker" [(ngModel)]="fromDate" (dateChange)="searchClick()">

    <mat-datepicker-toggle matSuffix [for]="fromPicker">
    </mat-datepicker-toggle>

    <mat-datepicker #fromPicker>
    </mat-datepicker>

  </mat-form-field>

  <mat-form-field appearance="outline">

    <mat-label>
      To Date
    </mat-label>

    <input matInput [matDatepicker]="toPicker" [(ngModel)]="toDate" (dateChange)="searchClick()">

    <mat-datepicker-toggle matSuffix [for]="toPicker">
    </mat-datepicker-toggle>

    <mat-datepicker #toPicker>
    </mat-datepicker>

  </mat-form-field>
  <!-- 
  <button
    mat-raised-button
    color="primary"
    (click)="searchClick()">

    <mat-icon>
      search
    </mat-icon>

    Search

  </button> -->

  <button mat-stroked-button color="primary" (click)="refresh()">

    <mat-icon>
      refresh
    </mat-icon>

    Refresh

  </button>

  <button class="onboard-btn" (click)="openPatientOnboard()">

    <mat-icon>
      person_add
    </mat-icon>

    Onboard Patient

  </button>

  <button class="create-btn" (click)="createRequisition.emit()">

    <mat-icon>description</mat-icon>

    Create Requisition

  </button>

</div>